import { render, staticRenderFns } from "./GalleryPage.vue?vue&type=template&id=9e45fd2e&"
import script from "./GalleryPage.vue?vue&type=script&lang=js&"
export * from "./GalleryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports